<template>
  <div>
    <PageTitle
      title="View Role"
      :backBtn="true"
      :editRoute="'role/edit/' + this.$route.params.id"
    />
    <v-container fluid class="lighten-12 container von-100">
      <v-container class="von-101">
        <v-row class="rowspace">
          <v-col cols="6">
            <v-row>
              <v-col cols="6" sm="12" md="6" lg="6"
                ><h4 class="hc-100">Name</h4></v-col
              >
              <v-col cols="6" sm="12" md="6" lg="6" style="text-align: right"
                ><v-chip label class="hr-100">
                  {{ role.name }}
                </v-chip></v-col
              ></v-row
            >
          </v-col>
          <v-col cols="6">
            <v-row>
              <v-col cols="6" sm="6" md="6" lg="6"
                ><h4 class="hc-100">Description</h4></v-col
              >
              <v-col cols="6" sm="6" md="6" lg="6" style="text-align: right">
                <v-chip label class="hr-100">
                  {{ role.description }}
                </v-chip></v-col
              ></v-row
            ></v-col
          >
        </v-row>
      </v-container>

      <!-- <v-col cols="6">
          <AuditLogs :Type="'role'" />
        </v-col> -->

      <v-row>
        <v-col>
          <v-card>
            <v-card-title class="hc-100">Permissions </v-card-title>
            <v-container fluid class="light gray lighten-12 pa-0">
              <v-simple-table>
                <template v-slot:default>
                  <v-expansion-panels>
                    <v-expansion-panel
                      v-for="(items, index) in policies"
                      :key="index"
                    >
                      <v-expansion-panel-header class="pl-2 hr-100">{{
                        index
                      }}</v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row
                          class="hr-100"
                          v-for="(item, key) in groupByModel(items)"
                          :key="key"
                        >
                          <v-col
                            cols="6"
                            sm="6"
                            lg="2"
                            class="permssion-checkbox"
                          >
                            {{ key }}
                          </v-col>

                          <v-col
                            cols="5"
                            sm="5"
                            lg="1"
                            v-for="(i, k) in item"
                            :key="k"
                            class="mr-10"
                          >
                            <v-checkbox
                              color="#002db3"
                              v-model="role.policies"
                              :value="i.id"
                              :label="i.action"
                              @change="
                                CheckedStatusOfAll(i.model, i.id, key, item)
                              "
                            ></v-checkbox
                          ></v-col>
                          <v-col cols="5" sm="5" lg="2">
                            <v-checkbox
                              color="#002db3"
                              v-model="checkSingleGroupData"
                              @change="checkSingleGroupPolicies(item, key)"
                              :value="key"
                              label="Check All"
                            ></v-checkbox
                          ></v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </template>
              </v-simple-table>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="4" lg="12">
          <AuditLogs :Type="'users'" />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="content-flex-end">
          <v-btn
            depressed
            small
            class="text-white btn_medium"
            to="/role"
            @click.stop="show = false"
            >Close</v-btn
          >
          <v-btn
            depressed
            small
            class="text-white btn_blue btn_medium w-100"
            @click="updateRole()"
            >Update</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { required, email, max } from 'vee-validate/dist/rules';
import {
  extend,
  ValidationObserver,
  ValidationProvider,
  setInteractionMode,
} from 'vee-validate';

import { Role } from '../../models/Role';
import _ from 'lodash';

extend('required', {
  ...required,
  message: '{_field_} is required',
});
export default {
  data: () => ({
    //roles: [],
    role: new Role(),
    errors: [],
    messages: [],
    roleHeaders: [
      { text: 'Name', value: 'name' },
      { text: 'Description', value: 'description' },
    ],
    policies: [],
    selected: [],
    checkAllGroupData: '',
    checkSingleGroupData: [],
  }),

  props: {},
  components: { ValidationProvider, ValidationObserver },

  methods: {
    loadRoledetails() {
      let id = this.$route.params.id;
      let self = this;
      this.$store.dispatch('user/getroleById', id).then((item) => {
        this.role = new Role().initialise(item.data);
        item.data.policies.map((data) => {
          let isValue = this.checkSingleGroupData.includes(data.model);
          if (isValue == false) {
            this.checkSingleGroupData.push(data.name);
          }
        });
      });
    },
    checkAllChange(items, rolePolicies, key) {
      let itemsFiltered = [];
      rolePolicies.map((r) => {
        let item = items.find((p) => p.id == r);
        if (item && item.model == key) {
          itemsFiltered.push(item);
        }
      });
      if (items.length !== itemsFiltered.length) {
        let index = this.checkSingleGroupData.findIndex((p) => p == key);
        if (index != -1) {
          this.checkSingleGroupData.splice(index, 1);
        }
      } else {
        this.checkSingleGroupData.push(key);
      }
    },

    CheckedStatusOfAll(Model, id, index, item) {
      if (!this.role.policies.includes(id)) {
        let index = this.checkSingleGroupData.indexOf(Model);
        if (index > -1) {
          this.checkSingleGroupData.splice(index, 1);
        }

        // let removed=policies.splice(index, 1);
        // let a= policies.filter(item=>item.model==Child.model)
      }
      var hadAllValues = true;
      item.forEach((item) => {
        if (!this.role.policies.includes(item.id)) {
          hadAllValues = false;
        }
      });
      if (hadAllValues) {
        this.checkSingleGroupData.push(Model);
      }
    },
    //create new role
    updateRole() {
      this.$store
        .dispatch('user/EditRole', this.role)
        .then((resp) => {
          this.$toast.success('Role updated successfully');
          this.$router.push('/role');
        })
        .catch((error) => console.log(error));
    },
    checkSingleGroupPolicies(items, key) {
      items.map((item) => {
        let isValue = this.role.policies.includes(item.id);
        if (isValue == true) {
          let index = this.role.policies.indexOf(item.id);
          if (index > -1 && !this.checkSingleGroupData.includes(key)) {
            this.role.policies.splice(index, 1);
          }
        } else if (this.checkSingleGroupData.includes(key)) {
          this.role.policies.push(item.id);
        }
      });
    },
    groupByModel(items) {
      return _.groupBy(items, 'model');
    },
  },
  created() {
    this.loadRoledetails();
    //this.GetPolicies();
  },
  mounted() {
    this.$store
      .dispatch('user/GetPolicies')
      .then((resp) => {
        this.policies = resp.data;
      })
      .catch((err) => {
        console.log('Role Details Error : ' + err);
      });
  },
};
</script>

<style>
.hc-100 {
  font-weight: 900;
}

.hr-100 {
  font-weight: bold;
}
.von-100 {
  background-color: white;
  margin-top: -40px;
}
.von-101 {
  margin-bottom: -39px;
}
</style>
